// @ts-strict-ignore
import { Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { filter } from 'rxjs/operators';
import XRegExp from 'xregexp';

@Directive({
  selector: '[inputRestricter]',
})
export class InputRestrictDirective implements OnChanges, OnInit, OnDestroy {
  @Input() inputRestricter;
  @Output() inputEvent = new EventEmitter<string>();

  oldValue = '';
  regexp: RegExp;
  position: number;
  private inputEventSubscription: Subscription;
  private focusinSubscription: Subscription;
  private focusoutSubscription: Subscription;
  private isElementInFocus: boolean = true;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.oldValue = this.elementRef.nativeElement.value;
    setTimeout(() => {
      this.oldValue = this.elementRef.nativeElement.value;
    }, 0);
    this.addSubscriptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inputRestricter.currentValue) {
      this.regexp = XRegExp(changes.inputRestricter.currentValue);
    }
  }

  ngOnDestroy(): void {
    if (this.focusinSubscription) {
      this.focusinSubscription.unsubscribe();
    }
    if (this.focusoutSubscription) {
      this.focusoutSubscription.unsubscribe();
    }
    if (this.inputEventSubscription) {
      this.inputEventSubscription.unsubscribe();
    }
  }

  private addSubscriptions(): void {
    this.focusinSubscription = fromEvent(this.elementRef.nativeElement, `focusin`, { capture: true }).subscribe(() => {
      this.isElementInFocus = true;
    });
    this.focusoutSubscription = fromEvent(this.elementRef.nativeElement, `focusout`, { capture: true }).subscribe(() => {
      this.isElementInFocus = false;
    });
    this.inputEventSubscription = fromEvent(this.elementRef.nativeElement, `input`, { capture: true })
      .pipe(
        filter((event: any) => {
          this.position = event.target.selectionStart;
          const newValue = event.target.value;
          const valid = this.regexp.test(newValue);
          if (!valid) {
            event.target.value = this.oldValue;
            if (this.isElementInFocus) {
              event.target.selectionStart = event.target.selectionEnd = this.position - 1;
            }
            this.inputEvent.emit(event.target.value);
          }
          return valid;
        })
      )
      .subscribe((event: any) => {
        this.oldValue = event.target.value;
        if (this.isElementInFocus) {
          event.target.selectionStart = event.target.selectionEnd = this.position;
        }
        this.inputEvent.emit(event.target.value);
      });
  }
}
